let apiURL;
let apiURLs;
let clientApiURL;
let clientURL;

apiURL = "https://commustateapibrd.mypatientclick.com"
// apiURLs="https://ringapi.panvatech.com"
apiURLs="https://api.ringremind.com"
// apiURLs="https://ringremindapilocal.mypatientclick.com";
// clientApiURL = "https://ringapi.panvatech.com"
clientApiURL = "https://api.ringremind.com"
// clientApiURL = "https://ringremindapilocal.mypatientclick.com"
clientURL = "https://ringreminduilocal.mypatientclick.com/conversations#/"

//apiURL = "https://localhost:44345"
export default {
  apiURL: apiURL,
  apiURLs: apiURLs,
  clientApiURL: clientApiURL,
  clientURL: clientURL,
  sessionAge: 6,
};
